import React from 'react';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { colors } from '../../styles/theme';

/*
 * Aviso de los diálogos de Meta (acciones F2a y crear campaña): uno solo por vista.
 * `info` (teal) · `warn` (ámbar, el mismo de «Sin confirmar»: plata real / medio de pago) · `error` · `neutral` (gris).
 */

export const META_NOTE_TONES = {
  info: { color: '#CFE6E5', border: alpha(colors.primaryLight, 0.3), bg: alpha(colors.primaryLight, 0.1), Icon: InfoOutlinedIcon },
  warn: { color: '#FFD2A8', border: alpha(colors.warning, 0.45), bg: alpha(colors.warning, 0.12), Icon: WarningAmberRoundedIcon },
  error: { color: colors.error, border: alpha(colors.error, 0.3), bg: alpha(colors.error, 0.08), Icon: ErrorOutlineIcon },
  // Gris: aviso sin plata ni bloqueo de Meta (p. ej. la causa genérica del parcial de crear).
  neutral: { color: '#E3E3E3', border: 'rgba(255,255,255,0.12)', bg: 'rgba(255,255,255,0.04)', Icon: InfoOutlinedIcon },
};

/** Botón / link de texto dentro del aviso («Ver en Meta», «Reconectar»…). */
export const metaNoteButtonSx = { textTransform: 'none', fontWeight: 600, px: 0, py: 0, minWidth: 0, fontSize: '13px', color: colors.primaryLight };

export default function MetaWriteNote({ tone = 'info', children, action = null, testId, codes = null }) {
  const t = META_NOTE_TONES[tone] || META_NOTE_TONES.info;
  const { Icon } = t;
  return (
    <Box
      role={tone === 'error' ? 'alert' : 'status'}
      data-testid={testId}
      data-tone={tone}
      data-codes={codes ? codes.join(' ') : undefined}
      sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', px: 1.5, py: 1, borderRadius: '8px', border: `1px solid ${t.border}`, bgcolor: t.bg }}
    >
      <Icon sx={{ fontSize: 18, color: t.color, mt: '1px', flexShrink: 0 }} aria-hidden />
      <Box sx={{ flex: 1, minWidth: 0, fontSize: '13px', lineHeight: '18px', color: t.color, alignSelf: 'center' }}>
        {children}
      </Box>
      {action ? (
        <Box sx={{ flexShrink: 0, alignSelf: 'center', display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>{action}</Box>
      ) : null}
    </Box>
  );
}
